import Login from 'components/Login'

export default function LoginPage() {
  return (
    <div className="login-page">
      <Login />
    </div>
  )
}
